import { Component, OnInit, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DataReportService } from '@app/_components/data-report/data-report.service';
import { PropertyService } from '@app/_components/property';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-google-data-table',
    templateUrl: './google-data-table.component.html',
    styleUrls: ['./google-data-table.component.css'],
    standalone: false
})
export class GoogleDataTableComponent implements OnInit {
  @Input() testName: string = '';

  formLoading = false;

  rows: Array<{
    createDate: string;
    shortTermRentalId?: number;
    queueStatus?: string;
    testResultDesc?: string;
  }> = [];

  properties: Array<{ shortTermRentalId: number; propertyCode: string }> = [];
  selectedShortTermRentalId?: number;

  // Lookback for the per-tab table. Backed by the new daysBack query param
  // on /dataReports/fetch-google-data/{testName} so the page no longer dumps
  // the entire history of str_data_report on every tab load.
  daysBack: number = 7;
  daysBackOptions = [
    { label: 'Last 1 day',   value: 1 },
    { label: 'Last 3 days',  value: 3 },
    { label: 'Last 7 days',  value: 7 },
    { label: 'Last 30 days', value: 30 }
  ];

  constructor(
    private messageService: MessageService,
    private dataReportService: DataReportService,
    private propertyService: PropertyService
  ) {}

  ngOnInit(): void {
    if (this.testName) {
      this.loadData();
    }
  }

  get filteredRows() {
    if (!this.selectedShortTermRentalId) {
      return this.rows;
    }
    return this.rows.filter(r => r.shortTermRentalId === this.selectedShortTermRentalId);
  }

  loadData(): void {
    if (!this.testName) {
      return;
    }
    this.formLoading = true;
    forkJoin([
      this.dataReportService.fetchGoogleData(this.testName, this.daysBack),
      this.propertyService.findAllSummary()
    ]).subscribe(
      ([reportRes, propRes]: any[]) => {
        const reports: any[] = reportRes?.data?.qualityTests || reportRes?.data?.dataReports || [];
        this.rows = reports.map(r => ({
          createDate: r?.createDate,
          shortTermRentalId: r?.shortTermRentalId != null && r?.shortTermRentalId !== '' ? Number(r.shortTermRentalId) : undefined,
          queueStatus: r?.queueStatus,
          testResultDesc: r?.testResultDesc
        }));

        const props: any[] = propRes?.data?.properties || [];
        this.properties = props.map(p => ({
          shortTermRentalId: p.shortTermRentalId,
          propertyCode: p.propertyCode
        }));
        this.formLoading = false;
      },
      (err: any) => {
        this.formLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.message || `Failed to load ${this.testName} data` });
      }
    );
  }

  /** Re-fetch when the user changes the lookback window. */
  onDaysBackChange(): void {
    this.loadData();
  }
}
